export default __webpack_public_path__ + "static/media/logo.7e4bd210.PNG";